
<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>SAION - Tecnología gubernamental</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i" rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>

<body>
  <header id="header" class="fixed-top">



    <!-- ======= Breadcrumbs ======= -->
    <section style="margin-top: -20px; background-color: black; margin-left: 10%; margin-right: 10%;width: 80%; height: 80%;" id="breadcrumbs" class="breadcrumbs">
      <div class="container">

        <div class="d-flex justify-content-between align-items-center">
          <h2 style="font-size: 2vh; color: rgb(255, 255, 255);"> Venustiano Carranza # 1, Col. Centro, C.P. 48900</h2>
          <ol>
            <h2 style="font-size: 2vh; color: rgb(255, 255, 255);" >317 382 5100</h2>
            <div class="header-social-links d-flex">

              <a style="color: aliceblue;" href="https://twitter.com/GobiernoAutlan" target="_blank"  class="twitter"><i class="bu bi-twitter"></i></a>
              <a style="color: aliceblue;" href="https://www.facebook.com/GobiernodeAutlan" target="_blank" class="facebook"><i class="bu bi-facebook"></i></a>
              <a style="color: aliceblue;" href="https://www.youtube.com/channel/UCCukDOtB-8M-VWL7gJZK01Q" target="_blank" class="youtube"><i class="bu bi-youtube"></i></a>
            </div>
          </ol>
        </div>

      </div>
    </section><!-- End Breadcrumbs -->


    <div class="container d-flex align-items-center">

      <img src="/assets/img/autlan-logo.PNG" alt="logo_SAION" height="70px" width="200px">
      <h1 class="logo me-auto"><a href="inicio"><span></span></a></h1>
      <!-- Uncomment below if you prefer to use an image logo -->
      <!-- <a href="index.html" class="logo me-auto me-lg-0"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->

      <nav id="navbar" class="navbar order-last order-lg-0">
        <ul>
          <li><a href="admin/indice" class="active">Inicio</a></li>

          <li><a >GOBIERNO</a></li>

          <li class="dropdown"><a href="#"><span>TRANSPARENCIA</span> <i class="bi bi-chevron-down"></i></a>
            <ul>

              <li class="dropdown"><a href="#"><span>H.AYUNTAMIENTO</span> <i class="bi bi-chevron-down"></i></a>
                <ul>
                  <li><a href="admin/articulo-8">ARTÍCULO 8</a></li>
                  <li><a href="admin/articulo-15">ARTÍCULO 15</a>
                    <li><a href="">NÓMINAS</a>
                  </li>
                </ul>
              </li>

              <!-- <li><a href="team.html" >Equipo</a></li> -->
              <!-- <li><a href="testimonials.html">Testimonios</a></li> -->


              <li class="dropdown"><a href="#"><span>DIF</span> <i class="bi bi-chevron-down"></i></a>
                <ul>
                  <!-- <li><a href="acerca-de">Articulo 8</a></li>
                  <li><a href="politica-de-privacidad">Articulo 15</a>
                    <li><a href="politica-de-privacidad">Nóminas</a>
                  </li> -->
                </ul>
              </li>
              <li class="dropdown"><a href="#"><span>INSTITUTO DE LA MUJER</span> <i class="bi bi-chevron-down"></i></a>
                <ul>
                  <!-- <li><a href="acerca-de">Articulo 8</a></li>
                  <li><a href="politica-de-privacidad">Articulo 15</a>
                    <li><a href="politica-de-privacidad">Nóminas</a>
                  </li> -->
                </ul>
              </li>

              <li class="dropdown"><a href="#"><span>INFORMACION FUNDAMENTAL</span> <i class="bi bi-chevron-down"></i></a>
                <ul>
                  <!-- <li><a href="acerca-de">Articulo 8</a></li>
                  <li><a href="politica-de-privacidad">Articulo 15</a>
                    <li><a href="politica-de-privacidad">Nóminas</a>
                  </li> -->
                </ul>
              </li>








            </ul>
          </li>

          <li><a >SESIONES</a></li>
          <li><a >TRAMITES Y SERVICIOS</a></li>
          <!--
          <li><a href="blog.html">Blog</a></li>
          <li><a href="contacto">Contacto</a></li> -->

        </ul>
        <i class="bi bi-list mobile-nav-toggle"></i>
      </nav><!-- .navbar -->



    </div>
  </header><!-- End Header -->







  <!-- ======= Hero Section ======= -->
  <section id="hero" style="height: 600px; margin-top: 100px; width: 80%; margin-left: 10%; margin-right: 10%;">


    <div id="heroCarousel" data-bs-interval="5000" class="carousel slide carousel-fade" data-bs-ride="carousel">

      <div class="carousel-inner" role="listbox">

        <!-- Slide 1 -->
        <div class="carousel-item active" style="background-image: url(assets/img/patrimonio.PNG);" >
          <div class="carousel-container">
            <!-- <div style="justify-content: center;" class="carousel-content animate__animated animate__fadeInUp">
              <h2 style="text-align: center;" >¿Quiénes <span>somos?</span></h2>
              <p style="text-align: center;">Somos una empresa mexicana con el objetivo principal de ofrecer sistemas de administración integral de manera online para nuestros clientes.</p>
              <div class="text-center"><a href="acerca-de" class="btn-get-started">Leer más</a></div>
            </div> -->
          </div>
        </div>

        <!-- Slide 2 -->
        <div class="carousel-item" style="background-image: url(assets/img/gob.PNG);">
          <div class="carousel-container">
            <!-- <div class="carousel-content animate__animated animate__fadeInUp">
              <h2 style="text-align: center;">Nuestro servicios</h2>
              <p>Contamos con soluciones creativas y escalables para todas sus necesidades de administración de recursos.</p>
              <div class="text-center"><a href="servicios" class="btn-get-started">Leer más</a></div>
            </div> -->
          </div>
        </div>

        <!-- Slide 3
        <div class="carousel-item" style="background-image: url(assets/img/slide/slide-1.jpg);">
          <div class="carousel-container">
            <div class="carousel-content animate__animated animate__fadeInUp">
              <h2 style="text-align: center;">Nuestros clientes</h2>
              <p>Nuestros clientes son la parte mas importante para nosotros y nuestros servicios son altamente personalizables.</p>
              <div class="text-center"><a href="servicios" class="btn-get-started">Leer más</a></div>
            </div>
          </div>
        </div> -->

      </div>

      <!-- <a class="carousel-control-prev" href="#heroCarousel" role="button" data-bs-slide="prev">
        <span class="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true"></span>
      </a>

      <a class="carousel-control-next" href="#heroCarouse2" role="button" data-bs-slide="next">
        <span class="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true"></span>
      </a>

      <ol class="carousel-indicators" id="hero-carousel-indicators"></ol> -->

    </div>








  </section><!-- End Hero -->

  <main id="main">

    <section id="testimonials" class="testimonials section-bg">
      <div class="container">

        <div class="row">
          <div class="section-title" data-aos="fade-up">
            <a style="font-size: 4vh;"
            href="https://www.youtube.com/watch?v=sLpCLunrUNM&list=PLviOcDYl4pq5TQuG6qZTjcug_VXW8lkmM"> Autlán TV  <strong>Noticias</strong></a>
           <h4>Videos del Ayuntamiento</h4>

          </div>

          <div class="col-lg-12" data-aos="fade-up">

            <img style="margin-left: 20%; margin-right: 20%;" src="https://i0.wp.com/autlan.gob.mx/wp-content/uploads/2022/09/portada-p-4.jpg?w=690" alt="">
          </div>



        </div>

      </div>
    </section><!-- End Testimonials Section -->



    <!-- ======= Our Team Section ======= -->
    <section id="team" class="team section-bg">
      <div class="container">

        <div class="section-title" data-aos="fade-up">
          <h2>Últimas  <strong>Noticias</strong></h2>
          <!-- <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint conse
            ctetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit sus
            cipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p> -->
        </div>

        <div class="row">

          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div  class="member" data-aos="fade-up">
              <div class="member-img">
                <img  src="/assets/img/noticia1.PNG" class="img-fluid" alt="">

              </div>
              <div class="member-info">
                <a style="font-size: 3vh;" href="https://autlan.gob.mx/convocatoria-y-reglas-de-operacion-del-programa-un-patrimonio-para-tu-familia/" >Listas de los 600 beneficiarios del programa Un Patrimonio para tu Familia</a>
                <span> H. Ayuntamiento octubre 11, 2022</span>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="100">
              <div class="member-img">
                <img src="/assets/img/noticia1.PNG" class="img-fluid" alt="">

              </div>
              <div class="member-info">
                <a href="https://autlan.gob.mx/convocatoria-y-reglas-de-operacion-del-programa-un-patrimonio-para-tu-familia/" style="font-size: 3vh;">CONVOCATORIA Y REGLAS DE OPERACIÓN DEL PROGRAMA “UN PATRIMONIO PARA TU FAMILIA”</a>
                <span> H. Ayuntamiento septiembre 20, 2022</span>
              </div>
            </div>
          </div>



          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="200">
              <div class="member-img">
                <img src="https://i0.wp.com/autlan.gob.mx/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-19-at-12.59.04-PM.jpeg?resize=768%2C512&ssl=1" class="img-fluid" alt="">
              </div>
              <div class="member-info">
                <a href="https://autlan.gob.mx/con-gran-animo-gustavo-robles-celebro-junto-a-miles-de-autlenses-el-grito-de-independencia/" style="font-size: 3vh;">Con gran ánimo Gustavo Robles celebró junto a miles de autlenses el Grito de Independencia</a>
                <span> H. Ayuntamiento septiembre 20, 2022</span>
              </div>
            </div>
          </div>



          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="300">
              <div class="member-img">
                <img src="https://i0.wp.com/autlan.gob.mx/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-12-at-11.39.15-AM.jpeg?resize=768%2C512&ssl=1" class="img-fluid" alt="">
              </div>
              <div class="member-info">
                <a style="font-size: 3vh;" href="https://autlan.gob.mx/12607-2/">Rinde Presidente Gustavo Robles primer informe de actividades</a>
                <span> H. Ayuntamiento septiembre 12, 2022</span>
              </div>
            </div>
          </div>




          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div  class="member" data-aos="fade-up">
              <div class="member-img">
                <img  src="https://i0.wp.com/autlan.gob.mx/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-12-at-11.39.16-AM.jpeg?resize=768%2C512&ssl=1" class="img-fluid" alt="">

              </div>
              <div class="member-info">
                <a style="font-size: 3vh;" href="https://autlan.gob.mx/rinde-presidenta-de-sistema-dif-autlan-primer-informe-de-actividades/" >
                  Rinde Presidenta de Sistema DIF Autlán primer informe de actividades</a>
                <span> H. Ayuntamiento Septiembre 12, 2022</span>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="200">
              <div class="member-img">
                <img src="https://i0.wp.com/autlan.gob.mx/wp-content/uploads/2022/08/WhatsApp-Image-2022-08-30-at-9.26.36-AM.jpeg?resize=768%2C512&ssl=1" class="img-fluid" alt="">
              </div>
              <div class="member-info">
                <a href="https://autlan.gob.mx/arranca-ciclo-escolar-2022-2023-y-entrega-de-paquetes-escolares-del-programa-recrea/" style="font-size: 3vh;">
                  Arranca ciclo escolar 2022-2023 y entrega de paquetes escolares del programa “Recrea”</a>
                <span> H. Ayuntamiento Agosto 30, 2022</span>
              </div>
            </div>
          </div>


          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="100">
              <div class="member-img">
                <img src="https://i0.wp.com/autlan.gob.mx/wp-content/uploads/2022/08/Captura.png?w=410&ssl=1" class="img-fluid" alt="">

              </div>
              <div class="member-info">
                <a href="https://autlan.gob.mx/licitacion-paneles-solares-del-rastro-municipal/" style="font-size: 3vh;">
                  Licitación: Paneles solares del rastro municipal</a>
                <span> H. Ayuntamiento Agosto 29, 2022</span>
              </div>
            </div>
          </div>









          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="300">
              <div class="member-img">
                <img src="https://i0.wp.com/autlan.gob.mx/wp-content/uploads/2022/08/Infografia-1-Conoce-los-instrumentos-que-norman-la-Contraloria-Socia.jpeg?resize=768%2C769&ssl=1" class="img-fluid" alt="">
              </div>
              <div class="member-info">
                <a style="font-size: 3vh;" href="https://autlan.gob.mx/conoce-los-instrumentos-que-norman-la-contraloria-social/">Conoce los instrumentos que norman la Contraloría Social</a>
                <span> H. Ayuntamiento Agosto 24, 2022</span>
              </div>
            </div>
          </div>











        </div>

      </div>
    </section><!-- End Our Team Section -->

  </main><!-- End #main -->

  <!-- ======= Footer ======= -->
  <footer id="footer">

    <div class="footer-top">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-md-6 footer-links">
            <img src="assets/img/logo.png" alt="">
           </div>



          <div class="col-lg-3 col-md-6 footer-contact">
            <h3>CONTACTO</h3>
            <p>
              Calle V. Carranza # 1 <br> Col. Centro, C.P. 48900 <br>
              Autlán,Jalisco<br>
              México <br><br>
              <strong>Télefono:</strong> +52 317 382 5100<br>
              <strong>Correo:</strong> contacto@autlan.gob.mx<br>

            </p>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4>Mapa del Sitio</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <a href="inicio">Inicio</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="https://autlan.gob.mx/directorio/">Directorio</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="inicio">Transparencia</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="https://autlan.gob.mx/tramites-y-servicios/">Tramites y Servicios</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="">Aviso de Privacidad</a></li>


            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4 >Redes Sociales</h4>
            <ul>
              <a href="https://twitter.com/GobiernoAutlan" target="_blank" class="twitter"><i class="bu bi-twitter"></i></a>
        <a href="https://www.facebook.com/GobiernodeAutlan" target="_blank" class="facebook"><i class="bu bi-facebook"></i></a>
        <a href="https://www.youtube.com/channel/UC
        CukDOtB-8M-VWL7gJZK01Q" target="_blank" class="youtube"><i class="bu bi-youtube"></i></a>


            </ul>
          </div>


        </div>
      </div>
    </div>

    <div class="container d-md-flex py-4">

      <div class="me-md-auto text-center text-md-start">
        <div class="copyright">
          &copy; A U T L Á N

         <strong><span>  GOBIERNO MUNICIPAL 2021 - 2024</span></strong>   © Copyright autlan.gob.mx
        </div>

      </div>

    </div>
  </footer><!-- End Footer -->

  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

  <!-- Vendor JS Files -->
  <script src="/assets/vendor/aos/aos.js"></script>
  <script src="/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="/assets/vendor/glightbox/js/glightbox.min.js"></script>
  <script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="/assets/vendor/swiper/swiper-bundle.min.js"></script>
  <script src="/assets/vendor/waypoints/noframework.waypoints.js"></script>
  <script src="/assets/vendor/php-email-form/validate.js"></script>

  <!-- Template Main JS File -->
  <script src="/assets/js/main.js"></script>

</body>

</html>
